<template>
    <div>
        <b-table v-if="visualizations.length > 0" class="table table-striped" :items="visualizations" :fields="fields" stacked="sm">
            <!-- A custom formatted column -->
            <template slot="type" slot-scope="data">
                <span v-if="data.item.type == 'pie'" class="ml-2" v-b-tooltip.hover title="Pie"><font-awesome-icon icon="chart-pie" /></span>
                <span v-else-if="data.item.type == 'mixed'" class="ml-2" v-b-tooltip.hover title="Mixed"><font-awesome-icon icon="layer-group" /></span>
                <span v-else-if="data.item.type == 'vbar'" class="ml-2" v-b-tooltip.hover title="Vertical Bar"><font-awesome-icon icon="chart-bar" /></span>
                <span v-else-if="data.item.type == 'bar'" class="ml-2" v-b-tooltip.hover title="Bar"><font-awesome-icon icon="chart-bar" /></span>
                <span v-else-if="data.item.type == 'line'" class="ml-2" v-b-tooltip.hover title="Line"><font-awesome-icon icon="chart-line" /></span>
                <span v-else-if="data.item.type == 'scatter-plot'" class="ml-2" v-b-tooltip.hover title="Scatter"><font-awesome-icon icon="scatter-plot" /></span>
                <span v-else-if="data.item.type == 'area'" class="ml-2" v-b-tooltip.hover title="Area"><font-awesome-icon icon="chart-area" /></span>
                <span v-else-if="data.item.type == 'bigNumber'" class="ml-2" v-b-tooltip.hover title="Number"><font-awesome-icon icon="sort-numeric-down" /></span>
                <span v-else-if="data.item.type == 'table'" class="ml-2" v-b-tooltip.hover title="Table"><font-awesome-icon icon="table" /></span>
                <span v-else>{{ data.item.type }}</span>
            </template>
            <template slot="actions" slot-scope="row">
                <b-button-group class="">
                    <button class="btn btn-xs btn-primary" v-b-tooltip.hover title="Edit"
                        @click="edit(row.item.id)">
                        <font-awesome-icon icon="edit" />
                    </button>
                    <button type="submit" class="btn btn-danger btn-xs" v-b-tooltip.hover title="Delete"
                            @click.prevent="del(row.item.id, row.index)"><font-awesome-icon icon="trash-alt" /></button>
                </b-button-group>
            </template>
            <template slot="updated" slot-scope="row">
				{{row.item.updated_at}}
			</template>
        </b-table>

        <div class="empty query" v-else>
            <p>
                You don't have any visualization yet.
            </p>
            <div>
                <router-link tag="a" class="btn btn-success" :to="{ name: 'visualization.create' }">
                    Make your first visualization.
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            visualizations: {
                type: Array,
                required: true
            },
            fields: {
                type: Array,
                default: () => ['title', 'type', 'description', 'updated', 'actions']
            }
        },
        data() {
            return {
                
            }
        },
        methods: {
            edit(id) {
                this.$router.push({ name: 'visualization.edit', params: { visualization_id: id } });
            },
            del(id, index) {
                this.$swal({
                    title: 'Be careful',
                    text: "Are you sure?",
                    type: 'warning',
                    width: '350px',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Confirm'
                }).then((result) => {
                    if (result.value) {
                        this.$store.dispatch('visualizations/delete', { id: id, index: index });
                    }
                })
            },
        },
    }
</script>
